import React from 'react'
import CategoryTitle from '../../CategoryTitle'
import SimpleBlockContent from '../../SimpleBlockContent'
import styles from './styles.module.css'
import Cta from '../../Cta'

function SectionTitle({ theme, category, title, text, textColor, leftAligned, noBottomPadding, cta }) {
  return (
    <div
      className={noBottomPadding ? `${styles.wrapper} ${styles.noBottomPadding}` : styles.wrapper}
      style={{ backgroundColor: theme.value }}
    >
      <div className={leftAligned ? `${styles.textAndCtasWrapper} ${styles.textAndCtasWrapperLeft}` : styles.textAndCtasWrapper}>
        {category && category.title.length > 0 && <CategoryTitle color={category.color.value}>{category.title}</CategoryTitle>}
        <div className={styles.title} style={{ color: textColor.value }}>
          <SimpleBlockContent blocks={title} noSpace />
        </div>
        <div className={styles.textBlock} style={{ color: textColor.value || '#fff' }}>
          {text && <SimpleBlockContent blocks={text} />}
        </div>
      </div>
      { cta && <div className={styles.ctaWrapper}><Cta fullHeight {...cta}/></div> }
    </div>
  )
}

export default SectionTitle
